// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".index .rsya-vertical{margin:auto;max-height:600px;overflow:hidden;text-align:center;width:240px}.index h1{margin:20px 0}.index .h2{font-size:2rem;font-weight:800;margin-bottom:10px;padding:0 10px}.index .total{color:hsla(0,0%,100%,.5);margin-bottom:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
